import React from 'react';

import { CmAlert, CmText } from '@/components/uiParts';

type Props = {
  pageName:
    | 'カテゴリ'
    | '商品'
    | 'メニュー'
    | 'オプショングループ'
    | 'メニュー提供時間';
};

export const CanNotUpdateMenuManagementNotice: React.FC<Props> = ({
  pageName,
}) => {
  return (
    <CmAlert>
      <CmText fontSize="sm" lineHeight="1.3">
        配信予約中は{pageName}の編集はできません。
      </CmText>
    </CmAlert>
  );
};
